export default __webpack_public_path__ + "static/media/gc-blue-white@2x.65d43d6b.png";